<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '14px' }"></ngx-loading>
  <div class="container" style="margin-top:240px">
    <div class="row">
      <div class="col-12">
          <div class="comment-wrapper d-flex">
              <div class="comment-author">
                  <img src="https://passport.petcart.in/images/blogimage/forum.jpg" alt="">
              </div>
              <!-- Comment Content -->
              <div class="comment-content" *ngIf="user">
                 
                  <h5>{{user.name}}</h5>
                 
              </div>
          </div>
      </div>
    </div>
      <div class="row" *ngIf="poststatus === 0 ;else formposted">
          <div class="col-12">
            <div class="card" style="padding:5px">
              <div class="card-header">
                <div class="row">
                  <div class="col-12 text-center">
                    <h4>Forum Submition Form</h4>
                  </div>
                </div>
              </div>
                <form (ngSubmit)="askToVet(f)" #f="ngForm"  enctype="multipart/form-data">
                  <div class="form-group">
                      <label for="pet_type">Select PetType</label>
                      <select *ngIf="pettype"    name="pettype" id="pettype"  [(ngModel)]="selected_pet_type" class="form-control" required>
                        <option *ngFor="let data of pettype" value="{{data.id}}">{{data.name}}</option>
                        </select>
                      </div>
                      <div class="form-group" *ngIf="selected_pet_type">
                          <label for="breed">Select Breed</label>
                          <select name="breed" id="breed" ngModel  class="form-control" required>
                            <option *ngFor="let data of breed | dynamicbreed22: selected_pet_type" value={{data.id}}>{{data.name}}</option>
                          </select>
                          </div>
                          <div class="form-group">
                              <label for="life">Select Lifestage</label>
                              <select *ngIf="lifestage"  name="life" id="life" ngModel class="form-control" required>
                                <option *ngFor=" let data of lifestage" value="{{data.id}}">{{data.name}}</option>
                              </select>
                        </div>
                        <div class="form-group">
                            <label for="cat">Select Category</label>
                            <select  name="cat" id="cat" ngModel class="form-control" required>
                              <option value="Behaviour">Behaviour</option>
                              <option value="Nutrition and Diet">Nutrition and Diet</option>
                              <option value="Healthcare">Healthcare</option>
                              <option value="care and General management">care and General management</option>
                            </select>
                            </div>
                            <div class="form-group">
                                <label for="title"> Title</label>
                                <input type="text" name="title" id="title" ngModel class="form-control" required>
                                </div>
                        <div class="form-group">
                                <label for="desc">Ask whatever you want</label>
                                <textarea name="desc" id="desc" cols="80" rows="10" ngModel class="form-control" required></textarea>
                      </div>
                  <div class="row">
                    <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                      <button type="submit" class="btn btn-success btn-block" [disabled]="!f.valid">Submit</button>
                    </div>
                    <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                        <button class="btn btn-success2 btn-block" (click)="goBack()">Go Back</button>  
                      </div>
                  </div>

                </form>
              </div>
            </div>
          </div>

  </div>
  <ng-template #formposted>
    <div class="row">
      <div class="col-12 text-center">
        <h4><p style="overflow-wrap: break-word; font-style: open sans;
          color:#9b7544">Your Question Has been successfully uploaded. Our Backend team will
        verify and published shortly</p></h4>
      </div>
      <div class="col-12 text-center">
        <button class="btn btn-success contact-btn"(click)="goBack()">Ok</button>
      </div>
    </div>
  </ng-template>